<template>
  <div class="container_box">
    <!--tab栏区域-->
    <Tabs v-model="pageParams.stockTab" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in orderTabTypeList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.stockTab === 'null'">
            <Form-item :label="$t('key1004334')" prop="stockOrderStatus">
              <Select v-model="pageParams.stockOrderStatus">
                <Option v-for="item in stockOrderStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004335')" prop="stockUpCodes">
              <Input type="textarea" :placeholder="$t('key1004336')" v-model.trim="pageParams.stockUpCodes"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_1"
              inputType="textarea"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList_1"
              :defaultSelectValue="defaultSelectValue_1"
              @changeInput="(val)=>changeInput(val, '_1')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004337')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registerTime"></Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_2"
              inputType="textarea"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList_2"
              :defaultSelectValue="defaultSelectValue_2"
              @changeInput="(val)=>changeInput(val, '_2')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <div class="table_header_box">
        <span v-for="item in tableColumns" :key="item.key" :style="{width: item.width}">{{ item.name }}</span>
      </div>
      <template v-if="tableData.length >0">
        <div class="distributorStock_box" v-for="(item, index) in tableData">
          <!--备货单-->
          <div class="pl20 flex align-items-center justify-content-between mb8">
            <div>
              <Tag color="primary" class="mr15">{{ item.orderStatusName }}</Tag>
              <span class="font-weight-bold color-333 mr15">{{ $t('key1004335') + item.stockUpCode }}</span>
              <span class="mr8">{{ $t('key1001180') + item.createdTime }}</span>
              <Tooltip max-width="300" placement="top" class="mr20" transfer>
                <template #content>
                  <p>{{ $t('key1001180') + item.createdTime }}</p>
                  <p>{{ $t('key1004338') + item.payTime }}</p>
                  <p v-if="item.status === 7">{{ $t('key1004339') + item.allottedTime }}</p>
                </template>
                <Icon type="ios-more" color="#2D8CF0" class="cursor mr15" size="20"/>
              </Tooltip>
              <span class="mr15" v-if="item.unadjustedPriceTalg">{{ $t('key1004340') + item.orderAmount }}</span>
              <span class="mr15" v-if="!item.unadjustedPriceTalg">{{ $t('key1004341') + item.orderOriginalAmount }}</span>
              <span class="mr15" v-if="!item.unadjustedPriceTalg">{{ $t('key1004342') + item.amountAfterPriceAdjustment }}</span>
              <span class="mr15" v-if="item.cancelledAmount && !(!item.payTime && item.status === 8)">{{ $t('key1004343') + item.newCanceledAmount }}</span>
              <span class="mr15" v-if="item.newRefundAmount">{{ $t('key1004344') + item.refundAmount }}</span>
              <span>{{ $t('key1004345') + item.distributorMerchantId }}</span>
            </div>
            <div class="flex align-items-center">
            <span class="themeColor cursor mr15" @click="$refs['priceAdjustment'].initPriceAdjustmentData(item)"
              v-if="item.status === 1 && getPermission('ymsStockUpInfo_saveBargain')">{{ $t('key1000162') }}</span>
              <span class="themeColor cursor mr15" @click="placeAnOrderBtn(item.ymsStockUpInfoId)"
                v-if="item.status === 1 && getPermission('ymsStockUpInfo_executeCreateOrder')">{{ $t('key1001936') }}</span>
              <span class="themeColor cursor mr15" @click="cancelOrderBtn(item.ymsStockUpInfoId)"
                v-if="['1','2','3'].includes(pageParams.stockTab) && getPermission('ymsStockUpInfo_cancelStockOrder')">{{ $t('key1004290') }}</span>
              <span class="themeColor cursor mr15" @click="$refs['commonLog'].initCommonLogData(item.ymsStockUpInfoId)">{{ $t('key1002478') }}</span>
            </div>
          </div>
          <!--子单-->
          <Collapse v-model="item.collapseValue">
            <Panel v-for="ele in item.ymsSubPackageInfoList" :name="ele.subPackageCode">
              <div class="subOrder_box" @click.stop>
                <span>{{ $t('key1004346') + ele.subPackageCode }}</span>
                <Icon class="ml8 mr15 cursor" color="#2D8CF0" size="18" type="ios-list-box" @click.stop="$refs['supplierOrdersLog'].initsupplierOrdersLogData(ele)"/>
                <Badge class="mr15" color="blue" :text="$t('key1001522') + ele.subOrderStatusName"/>
                <span class="mr8">{{ $t('key1001180') + ele.createdTime }}</span>
                <Tooltip max-width="300" placement="top" class="mr20" transfer>
                  <template #content>
                    <p>{{ $t('key1001180') + ele.createdTime }}</p>
                    <p>{{ $t('key1004347') + ele.shipedTime }}</p>
                    <p>{{ $t('key1004348') + ele.storageTime }}</p>
                    <p>{{ $t('key1004339') + ele.finishTime }}</p>
                  </template>
                  <Icon type="ios-more" color="#2D8CF0" class="cursor mr15" size="20"/>
                </Tooltip>
                <span class="mr15">{{ $t('key1003343') + ele.supplierMerchantId }}</span>
                <p class="mr15" v-if="ele.orderStatus === 2 && ele.transportType !== 2" @click.stop="jumpToTheCourierInquiry(ele.expressageCode, ele.expressageNo, ele.trackingNumber)">
                  <span>{{ $t('key1004362') }}</span>
                  <span class="themeColor cursor">{{ ele.expressageNo }}</span>
                </p>
                <span class="mr15" v-if="ele.orderStatus === 2 && ele.transportType === 2">{{ `${configCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}` }}</span>
                <span class="mr15" v-if="ele.sub_unadjustedPriceTalg">{{ $t('key1004349') + ele.originalPrice }}</span>
                <span class="mr15" v-if="!ele.sub_unadjustedPriceTalg">{{ $t('key1000299') + ele.originalPrice }}</span>
                <span class="mr15" v-if="!ele.sub_unadjustedPriceTalg">{{ $t('key1004350') + ele.priceAdjustment }}</span>
                <span class="mr15" v-if="ele.orderStatus === 4">{{ $t('key1004351') + ele.balance }}</span>
              </div>
              <!--sku信息-->
              <div slot="content" class="skuInfo_box">
                <div class="flex justify-content-around mb12" v-for="talg in ele.ymsSubPackageGoodsList">
                  <!--图片-->
                  <div class="flex width_400 pr20" v-viewer="viewerConfig">
                    <div class="img_box">
                      <img
                        :src="setImgPath(talg.primaryImage, null, '70x70', null, true)"
                        :data-original="setImgPath(talg.primaryImage, null, null, null, false)"
                        @error="setErrorImg($event)" alt="">
                    </div>
                    <div class="ml8 flex_1">
                      <div class="flex flex-wrap">
                        <Tag color="primary" class="font-size-12 mr8 width_65" v-if="talg.isSelfOperated === 1">{{ $t('key1004308') }}</Tag>
                        <p class="font-weight-bold color-333">{{ talg.spuName }}</p>
                      </div>
                      <p>
                        <span class="font-weight-bold color-333">{{ configCharacters(false) + 'SPU：'}}</span>
                        <span>{{ talg.ymsSpu }}</span>
                      </p>
                      <p>
                        <span class="font-weight-bold color-333">{{ configCharacters(false) + 'SKU：'}}</span>
                        <span>{{ talg.ymsSku }}</span>
                      </p>
                      <p class="color-green">{{ talg.specifications }}</p>
                    </div>
                  </div>
                  <!--单价-->
                  <div class="width_100">
                    <p v-if="talg.originalPriceTalg">{{ $t('key1004352') + (isValueEmpty(talg.originalProductGoodsCost) ? '-' : talg.originalProductGoodsCost) }}</p>
                    <p v-if="talg.originalPriceTalg">{{ $t('key1004353') + (isValueEmpty(talg.productGoodsCost) ? '-' : talg.productGoodsCost) }}</p>
                    <p v-else>{{ $t('key1004354') + (isValueEmpty(talg.originalProductGoodsCost) ? '-' : talg.originalProductGoodsCost) }}</p>
                  </div>
                  <!--订单数量-->
                  <div class="width_130">{{ $t('key1004355') + (isValueEmpty(talg.originalQuantity) ? '-' : talg.originalQuantity) }}</div>
                  <!--收货数量-->
                  <div class="width_130">{{ $t('key1004356') + (isValueEmpty(talg.actualSortingNumber) ? '-' : talg.actualSortingNumber) }}</div>
                  <!--上架数量-->
                  <div class="width_130">{{ $t('key1004357') + (isValueEmpty(talg.shelveQuantity) ? '-' : talg.shelveQuantity) }}</div>
                  <!--取消数量-->
                  <div class="width_130">{{ $t('key1004358') + (isValueEmpty(talg.cancelQuantity) ? '-' : talg.cancelQuantity) }}</div>
                  <!--退款数量-->
                  <div class="width_130">{{ $t('key1004359') + (isValueEmpty(talg.refundQuantity) ? '-' : talg.refundQuantity) }}</div>
                  <!--异常状态-->
                  <div class="width_240">
                    <p>{{ $t('key1004363') }}</p>
                    <template v-if="talg.goodsStatus === 2">
                      <p class="crimsonRedColor">{{ $t('key1000084') }}</p>
                      <p class="crimsonRedColor">{{ $t('key1004360') + talg.outOfStockQuantity }}</p>
                    </template>
                    <template v-else>
                      <template v-if="talg.abnormalStatus === 2">
                        <p class="crimsonRedColor">{{ $t('key1004364') }}</p>
                        <p class="crimsonRedColor" v-if="talg.estimateArrivalOfGoodsTime">{{ $t('key1004361') + talg.estimateArrivalOfGoodsTime }}</p>
                        <p class="crimsonRedColor">{{ $t('key1004360') + talg.outOfStockQuantity }}</p>
                      </template>
                      <template v-else>
                        <span>-</span>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </template>
      <template v-else>
        <!--暂无数据-->
        <div class="no_classify">
          <img :src="noContent" width="250" height="250" :alt="$t('key1000104')">
        </div>
      </template>
    </div>
    <!--调价弹窗-->
    <priceAdjustmentModal ref="priceAdjustment" @updateData="pageParamsStatus = true"></priceAdjustmentModal>
    <!--订单日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_DISTRIBUTOR"></commonLogModal>
    <!--供应商子单日志弹窗-->
    <supplierOrdersLogModal ref="supplierOrdersLog"></supplierOrdersLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import priceAdjustmentModal from "@/views/yms/components/orderList/priceAdjustmentModal.vue";
import {amountHandel, getDataSetBatchList, getEnumList, isValueEmpty, jumpToTheCourierInquiry} from "@/utils/common";
import commonLogModal from "@/components/common/commonLogModal.vue";
import supplierOrdersLogModal from "@/views/yms/components/orderList/supplierOrdersLogModal.vue";
import {startLoading, endLoading} from "@/utils/loading";

export default {
  name: 'distributorStockList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      noContent: require('@/assets/images/noDataIcon.png'),
      pageParamsStatus: false,
      pageParams: {
        stockOrderStatus: 'null',
        stockTab: 'null', // null.全部 1.待调价 2.待供应商接单 3.待分销商付款 4.待发货 5.待入库(已发货) 51.待分拣 52 待上架 6.已完成 7.已取消
        stockUpCodes: '',
        createdStartTime: null,
        createdEndTime: null,
        ymsSpus: '',
        ymsSkus: '',
        distributorMerchantIds: '',
        supplierMerchantIds: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {width: '400px', key: 'productInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383')},
        {width: '100px', key: 'amountOfGoods', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003673')},
        {width: '130px', key: 'orderQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803')},
        {width: '130px', key: 'receivedQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004316')},
        {width: '130px', key: 'numberOfListings', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003963')},
        {width: '130px', key: 'cancelQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004317')},
        {width: '130px', key: 'refundQuantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004318')},
        {width: '240px', key: 'abnormalState', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')},
      ],
      tableData: [],
      priceToBeAdjustedTotal: 0,
      pendingOrdersTotal: 0,
      obligationTotal: 0,
      orderTabTypeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {
          value: '1',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004319')),
              h('Badge', {
                props: {
                  count: v.priceToBeAdjustedTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {
          value: '2',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004320')),
              h('Badge', {
                props: {
                  count: v.pendingOrdersTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {
          value: '3',
          title: (h) => {
            return h('div', [
              h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004321')),
              h('Badge', {
                props: {
                  count: v.obligationTotal,
                  overflowCount: 999
                }
              })
            ]);
          }
        },
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: '5', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004322')},
        {value: '51', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004192')},
        {value: '52', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004064')},
        {value: '6', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563')},
        {value: '7', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')}
      ],
      registerTime: [],
      dropDownInputList_1: [
        {title: 'SPU', value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004323'), parameterKey: 'ymsSpus'},
        {title: 'SKU', value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004324'), parameterKey: 'ymsSkus'}
      ],
      dropDownInputList_2: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004325'), parameterKey: 'distributorMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004326'), parameterKey: 'supplierMerchantIds'}
      ],
      defaultSelectValue_1: 1,
      defaultSelectValue_2: 1,
      stockOrderStatusList: [
        {value: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004319')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004320')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004321')},
        {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004322')},
        {value: 51, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004192')},
        {value: 52, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004064')},
        {value: 6, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563')},
        {value: 7, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')}
      ],
      timer: null,
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      let arr = [...this.dropDownInputList_1, ...this.dropDownInputList_2];
      let list = arr.map((item) => {
        return item.parameterKey;
      });
      return [...list, 'stockUpCodes'];
    },
    // 预览图配置
    viewerConfig() {
      return {
        url: 'data-original',
        ...this.viewerOptions
      };
    },
    // 状态
    distributorStockUpStatus() {
      const ENUM_KEY = 'YmsStockUpInfoStatusCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
  },
  created() {
    this.initFun();
  },
  methods: {
    isValueEmpty,
    jumpToTheCourierInquiry,
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = ['YmsStockUpInfoStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await this.getPendingProcessingNum();
        await this.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let {stockOrderStatus, ...params} = v.pageParams;
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      if (v.pageParams.stockTab === 'null') {
        params.stockTab = v.pageParams.stockOrderStatus === 'null' ? null : v.pageParams.stockOrderStatus;
      } else {
        params.stockTab = Number(v.pageParams.stockTab);
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.getPendingProcessingNum();
      if (v.getPermission('ymsStockUpInfo_query')) {
        v.timer = setInterval(() => {
          startLoading(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003332'));
        }, 20);
        v.tableLoading = true;
        v.axios.post(api.post_ymsStockUpInfo_query, v.handleParameter()).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            v.total = data.total;
            v.handleTableData(list);
          } else {
            endLoading();
            clearInterval(v.timer);
          }
        }).catch(() => {
          endLoading();
          clearInterval(v.timer);
        });
      } else {
        v.gotoError();
      }
    },
    // 处理列表数据
    handleTableData(data) {
      let v = this;
      let ymsProductGoodsIds = [];
      let allYmsProductGoodsIds = [];
      if (data.length > 0) {
        data.map((item) => {
          let ymsSubPackageInfoList = item.ymsSubPackageInfoList || [];
          ymsSubPackageInfoList.map((ele) => {
            let ymsSubPackageGoodsList = ele.ymsSubPackageGoodsList || [];
            ymsSubPackageGoodsList.map((talg) => {
              if (talg.ymsProductGoodsId) {
                allYmsProductGoodsIds.push(talg.ymsProductGoodsId);
              }
            });
          });
        });
        ymsProductGoodsIds = v.uniqueFunc(allYmsProductGoodsIds);
        if (ymsProductGoodsIds.length > 0) {
          v.getProductInfoByIds(ymsProductGoodsIds, null, false, true).then((goodsData) => {
            data.map((item) => {
              item.collapseValue = [];
              let unadjustedPriceTalg = item.ymsStockUpGoods.every((ele) => {
                return ele.originalProductGoodsCost === ele.productGoodsCost;
              });
              // 子单
              let ymsSubPackageInfoList = item.ymsSubPackageInfoList || [];
              ymsSubPackageInfoList.map((ele) => {
                let ymsSubPackageGoodsList = ele.ymsSubPackageGoodsList || [];
                // 状态
                let sub_statusList = [
                  {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
                  {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
                  {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004328')},
                  {value: 4, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003563')},
                  {value: 5, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
                ];
                sub_statusList.map((talg) => {
                  if (talg.value === ele.orderStatus) {
                    ele.subOrderStatusName = talg.name;
                  }
                });
                // 时间
                ele.createdTime = v.$uDate.dealTime(ele.createdTime, 'fulltime') || '-';
                ele.shipedTime = v.$uDate.dealTime(ele.shipedTime, 'fulltime') || '-';
                ele.storageTime = v.$uDate.dealTime(ele.storageTime, 'fulltime') || '-';
                ele.finishTime = v.$uDate.dealTime(ele.finishTime, 'fulltime') || '-';
                // 金额
                ele.originalPrice = hanleData(ele.originalTotalPrice, ele.originalTotalPriceCurrency);
                ele.priceAdjustment = hanleData(ele.adjustPrice, ele.adjustPriceCurrency);
                ele.balance = hanleData(ele.settlementAmount, ele.settlementAmountCurrency);
                ele.sub_unadjustedPriceTalg = ymsSubPackageGoodsList.every((ele) => {
                  return ele.originalProductGoodsCost === ele.productGoodsCost;
                });
                
                // sku信息
                ymsSubPackageGoodsList.map((talg, idx) => {
                  talg.id = idx;
                  talg.originalPriceTalg = talg.originalProductGoodsCost !== talg.productGoodsCost;
                  talg.estimateArrivalOfGoodsTime = v.$uDate.dealTime(talg.estimateArrivalOfGoodsTime);
                  goodsData.map((k) => {
                    let ymsProductGoodsList = k.ymsProductGoodsList || [];
                    ymsProductGoodsList.map((g) => {
                      g.name = k.name;
                      g.ymsSpu = k.ymsSpu;
                      g.isSelfOperated = k.isSelfOperated;
                    });
                    ymsProductGoodsList.map((j) => {
                      if (talg.ymsProductGoodsId === j.ymsProductGoodsId) {
                        talg.spuName = j.name;
                        talg.primaryImage = j.primaryImage;
                        talg.isSelfOperated = j.isSelfOperated;
                        let productGoodsSpecificationList = j.productGoodsSpecificationList || [];
                        let list = productGoodsSpecificationList.map((p) => {
                          return p.value;
                        });
                        talg.specifications = list.join(' • ');
                        talg.ymsSku = j.ymsSku;
                        talg.ymsSpu = j.ymsSpu;
                      }
                    });
                  });
                });
              });
              v.distributorStockUpStatus.map((ele) => {
                if (ele.value === item.status) {
                  item.orderStatusName = ele.name;
                }
              });
              // 时间
              item.createdTime = v.$uDate.dealTime(item.createdTime, 'fulltime') || '-';
              item.payTime = v.$uDate.dealTime(item.payTime, 'fulltime') || '-';
              item.allottedTime = v.$uDate.dealTime(item.allottedTime, 'fulltime') || '-';
              // 金额
              item.unadjustedPriceTalg = unadjustedPriceTalg;
              item.newRefundAmount = item.refundAmount;
              item.orderAmount = hanleData(item.totalPrice, item.totalPriceCurrency);
              item.orderOriginalAmount = hanleData(item.originalProductGoodsTotalPrice, item.originalProductGoodsTotalPriceCurrency);
              item.amountAfterPriceAdjustment = hanleData(item.adjustPrice, item.adjustPriceCurrency);
              item.newCanceledAmount = hanleData(item.cancelledAmount, item.cancelledCurrency);
              item.refundAmount = hanleData(item.refundAmount, item.refundAmountCurrency);
            });
            v.tableData = data;
            endLoading();
            clearInterval(v.timer);
          }).catch(() => {
            endLoading();
            clearInterval(v.timer);
          });
        }
      } else {
        endLoading();
        clearInterval(v.timer);
      }

      function hanleData(priceValue, currencyVal) {
        let price = amountHandel(priceValue);
        let currency = currencyVal || v.currencyState;
        return !isValueEmpty(price) ? (price + ' ' + currency) : '-';
      }
    },

    // 切换Tab
    changeTab(value) {
      let v = this;
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.resetDate();
        v.pageParams.pageNum = 1;
        v.pageParamsStatus = true;
        v.$forceUpdate();
      });
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.changeInput(1, '_1');
      v.changeInput(1, '_2');
      v.registerTime = [];
      v.resetDate();
      v.getList();
    },
    // 重置时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value, type) {
      this['defaultSelectValue' + type] = value;
      this.$refs['dropDownFilter' + type].inputValue = '';
      this['dropDownInputList' + type].map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 获取待处理的数量
    getPendingProcessingNum() {
      let v = this;
      v.axios.get(api.get_ymsStockUpInfo_queryTabTotal).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.priceToBeAdjustedTotal = data.priceToBeAdjusted || 0;
            v.pendingOrdersTotal = data.pendingOrders || 0;
            v.obligationTotal = data.obligation || 0;
          } else {
            v.priceToBeAdjustedTotal = 0;
            v.pendingOrdersTotal = 0;
            v.obligationTotal = 0;
          }
        }
      });
    },
    // 下单
    placeAnOrderBtn(ymsStockUpInfoId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004329'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004330'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004331'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsStockUpInfo_executeCreateOrder + ymsStockUpInfoId,
            null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004332'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 取消订单
    cancelOrderBtn(ymsStockUpInfoId) {
      this.axios.get(api.get_ymsStockUpInfo_cancelStockOrder + ymsStockUpInfoId).then((response) => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004333'));
          this.pageParamsStatus = true;
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    supplierOrdersLogModal,
    commonLogModal,
    dropDownFilter,
    priceAdjustmentModal
  }
};
</script>

<style lang="less" scoped>
.distributorStock_box {
  /deep/ .ivu-collapse {
    margin-bottom: 15px;

    .ivu-collapse-header {
      display: flex;
      align-items: center;
    }
  }

  .subOrder_box {
    display: flex;
    align-items: center;
    width: 100%;
    z-index: 10;
    cursor: default;
  }

  .skuInfo_box {
    max-height: 600px;
    overflow-y: auto;

    .img_box {
      width: 70px;
      height: 70px;
      position: relative;
      cursor: pointer;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }
  }
}

.table_header_box {
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  height: 35px;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
  color: #000;
  margin-bottom: 15px;
}

.no_classify {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;

  .txt {
    font-size: 15px;
    color: #666;
    margin-top: 15px;
  }
}

</style>

